import Menu from "./menu";
import { Link } from "react-router-dom";
import RoutesInstance from "@routes/instances";

const Header = () => {
    return (
        <header className="bg-blue-500 text-white dashboard-header">
            <section className="root-container-fluid h-full">
                <div className="flex items-stretch h-full">
                    <Link
                        to={RoutesInstance.dashboard}
                        className="ml-4 my-auto hidden sm:inline-block">
                        <img
                            src="/images/logo-dark.png"
                            alt="وینکا"
                            width={64}
                        />
                    </Link>

                    <Menu />
                </div>
            </section>
        </header>
    );
};

export default Header;
